import { c as _c } from "react/compiler-runtime";
import React, { ForwardedRef, forwardRef } from 'react';
import type { EshopBox as EshopBoxType } from './types';
import { EshopBox, EshopBoxPlaceholder } from './EshopBox';
import { mergeClasses } from '@/utils/style';
export type CmsEshopItem = {
  file: {
    asset: {
      url: string;
      metadata: {
        dimensions: {
          width: number;
          height: number;
        };
      };
    };
  };
  link: string;
  name: string;
};
function getMaxHeightByWidth(maxWidth: NonNullable<EshopBoxType['maxWidth']>, originalWidth: number, originalHeight: number) {
  const ratio = originalWidth / originalHeight;
  return Math.round(maxWidth / ratio);
}
export const cmsItemsToEshops = ({
  items,
  imageSize,
  maxWidth,
  size,
  index,
  section
}: {
  items: CmsEshopItem[];
  imageSize: EshopBoxType['image']['size'];
  maxWidth?: EshopBoxType['maxWidth'];
  size: EshopBoxType['size'];
  index: EshopBoxType['index'];
  section: EshopBoxType['section'];
}) => {
  return items.map(item => ({
    size,
    link: item.link,
    image: {
      url: item.file.asset.url,
      title: item.name,
      size: imageSize,
      width: maxWidth ?? item.file.asset.metadata.dimensions.width,
      height: maxWidth !== undefined ? getMaxHeightByWidth(maxWidth, item.file.asset.metadata.dimensions.width, item.file.asset.metadata.dimensions.height) : item.file.asset.metadata.dimensions.height
    },
    index,
    section
  }));
};
const EshopBoxes = forwardRef(function EshopBoxes(t0, ref) {
  const $ = _c(19);
  const {
    eshops,
    className,
    boxSize,
    imageSizes,
    isLoading,
    loadingMethod,
    priorityCount: t1,
    placeholderCount: t2
  } = t0;
  const priorityCount = t1 === undefined ? 0 : t1;
  const placeholderCount = t2 === undefined ? 6 : t2;
  const t3 = boxSize === "wide" ? "grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3" : "flex flex-row flex-wrap justify-center gap-4";
  const t4 = boxSize === "md" && "lg:gap-8";
  let t5;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4) {
    t5 = mergeClasses(t3, t4, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== boxSize || $[5] !== eshops || $[6] !== imageSizes || $[7] !== loadingMethod || $[8] !== priorityCount) {
    t6 = eshops?.map((eshop, key) => <EshopBox imageSizes={imageSizes} {...eshop} key={key} loading={loadingMethod} priority={key < priorityCount} size={boxSize} index={key} />);
    $[4] = boxSize;
    $[5] = eshops;
    $[6] = imageSizes;
    $[7] = loadingMethod;
    $[8] = priorityCount;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== boxSize || $[11] !== isLoading || $[12] !== placeholderCount) {
    t7 = isLoading && <>{Array.from({
        length: placeholderCount
      }).map((_, index) => <EshopBoxPlaceholder key={index} size={boxSize} />)}</>;
    $[10] = boxSize;
    $[11] = isLoading;
    $[12] = placeholderCount;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== ref || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t5} ref={ref}>{t6}{t7}</div>;
    $[14] = ref;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
});
export default EshopBoxes;